import CompareDrawerPlaceholder from './CompareDrawerPlaceholder';

export default CompareDrawerPlaceholder;
